<template>
  <div class="item">
    <a :href="item.link.url" class="b-article">
      <div class="b-article__body">
        <div class="b-article__title">{{ item.title }}</div>
        <div class="b-article__summary" v-html="item.summary"></div>
      </div>
      <i class="icon-arrow-right b-article__btn"></i>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
}
</script>
